module.exports = __webpack_public_path__ + "static/media/flag-level-zero.7c8f7114.svg";